/**
 * BrowseIrcons.jsx
 * Created by Destin Frasier on 11/20/18.
 */

import BrowserIconSingleton from './browserIconSingleton';
import BaseIcon from '../BaseIcon';


class BrowserIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = BrowserIconSingleton;
    }
}

export class BrowserIconChrome extends BrowserIcon {}
BrowserIconChrome.defaultProps = {
    iconName: 'rec-icon-browser-chrome',
    iconClass: 'rec-icon-browser-chrome',
    alt: 'Chrome'
};

export class BrowserIconEdge extends BrowserIcon {}
BrowserIconEdge.defaultProps = {
    iconName: 'rec-icon-browser-edge',
    iconClass: 'rec-icon-browser-edge',
    alt: 'Edge'
};

export class BrowserIconFirefox extends BrowserIcon {}
BrowserIconFirefox.defaultProps = {
    iconName: 'rec-icon-browser-firefox',
    iconClass: 'rec-icon-browser-firefox',
    alt: 'Firefox'
};

export class BrowserIconSafari extends BrowserIcon {}
BrowserIconSafari.defaultProps = {
    iconName: 'rec-icon-browser-safari',
    iconClass: 'rec-icon-browser-safari',
    alt: 'Safari'
};